import { lazy } from 'react'

export const FastingAtWeekend = lazy(() => import('./FastingAtWeekend'))
